var render = function render(){var _vm=this,_c=_vm._self._c;return _c('accordion-list',{attrs:{"class-name":"faq-list--dark","faq-list":_vm.faqList[0]['list']}})
}
var staticRenderFns = []

export { render, staticRenderFns }